import { InputRichText, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { copilotDropdownFeatureFlags } from 'components/copilotDropdown/copilotDropdown.constants';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { pubSub } from 'utils/pubSub';
import { useCopilotTrial } from 'utils/useCopilotTrial';

export const CustomAiDraft = (): JSX.Element | null => {
  const { hasCopilot } = useCopilotTrial();
  const flags = useFeatureFlag(copilotDropdownFeatureFlags);

  // Opens the Custom Mim drafts panel in the copilot dropdown on the next tick, so
  // the click does not reach the dropdown's outside-click listener.
  const onClickHandler = useCallback(() => {
    setTimeout(() => {
      pubSub.publish('command:richTextEditor:customAiDraft');
    });
  }, []);

  if (!hasCopilot || !flags.mimDrafts) {
    return null;
  }

  return (
    <Tooltip
      content={
        <CommandKeybindingsTooltipContent commandName="richTextEditor:customAiDraft">
          Custom Mim drafts
        </CommandKeybindingsTooltipContent>
      }
    >
      <InputRichText.ToolbarButton icon="mim" onClick={onClickHandler} />
    </Tooltip>
  );
};
